/** Fixed names/content for pregnant profile walkthroughs (no real client data). */

export const DUMMY_MOTHER_FIRST_NAME = 'Lethabo';
export const DUMMY_MOTHER_SURNAME = 'Mokoena';

export const dummyMotherWalkthroughLabel = `${DUMMY_MOTHER_FIRST_NAME} ${DUMMY_MOTHER_SURNAME}`;

export const dummyMotherProgressData = {
  progressBar: {
    message: `${DUMMY_MOTHER_FIRST_NAME} is doing well!`,
    label: '6/6',
    value: 100,
    primaryColour: 'successMain' as const,
    secondaryColour: 'successBg' as const,
  },
  infoCard: {
    success: [
      {
        comment: `No danger signs for ${DUMMY_MOTHER_FIRST_NAME}`,
        section: 'Clinic visits',
        visitData: { visitName: 'Danger signs' },
      },
    ],
  },
};

export const dummyMotherReferralsData = {
  sections: [
    {
      label: 'Clinic referrals:',
      value: 'clinicReferrals',
    },
  ],
  questions: {
    clinicReferrals: [
      {
        id: 'walkthrough-ref-01',
        comment: 'Missed clinic visit',
        isCompleted: false,
        insertedDate: new Date(),
      },
      {
        id: 'walkthrough-ref-02',
        comment: 'Immunisations and Vitamin A not up to date',
        isCompleted: false,
        insertedDate: new Date(),
      },
    ],
  },
  completedReferrals: [
    {
      id: '01',
      comment: 'MUAC is less than 22cm',
      isCompleted: false,
      insertedDate: new Date(),
    },
  ],
};
